module.exports = __webpack_public_path__ + "img/business.2ff450ba.png";